import type { DateTime } from "luxon";
import type { FC, PropsWithChildren } from "react";
import { useHospitalData } from "../../../../contexts/HospitalDataProvider";
import { ScheduleHolidaysContext } from "./scheduleHolidaysContext";
import { useScheduleHolidays } from "./useScheduleHolidays";

type Props = PropsWithChildren<{
	/** The schedule's first and last day as the page has them: from the schedule cache with `staffing_schedule_cache` on, the old list off. */
	firstDate: DateTime | undefined;
	lastDate: DateTime | undefined;
}>;

/**
 * Loads the holidays of the schedule's days, once for the page, for every day header, column and shift below it. One
 * range for all of it, so moving between days or weeks asks for nothing new.
 */
export const ScheduleHolidaysProvider: FC<Props> = ({ firstDate, lastDate, children }) => {
	const { chosenDepartment } = useHospitalData();
	// No request until the schedule has a day: before that there is no day to mark.
	const scheduleHolidays = useScheduleHolidays(
		chosenDepartment.department_id,
		firstDate === undefined || lastDate === undefined ? null : { from: firstDate, to: lastDate },
	);
	return <ScheduleHolidaysContext.Provider value={scheduleHolidays}>{children}</ScheduleHolidaysContext.Provider>;
};
